module.exports = __webpack_public_path__ + "static/media/Imagenes-Blog8-1024x481.286c151a.png";